import { render, staticRenderFns } from "./Rank.vue?vue&type=template&id=3f0a8b20&scoped=true"
import script from "./Rank.vue?vue&type=script&lang=js"
export * from "./Rank.vue?vue&type=script&lang=js"
import style0 from "./Rank.vue?vue&type=style&index=0&id=3f0a8b20&prod&lang=scss"
import style1 from "./Rank.vue?vue&type=style&index=1&id=3f0a8b20&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f0a8b20",
  null
  
)

export default component.exports